import { render } from "./DataTable.vue?vue&type=template&id=5788b29b&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=5788b29b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5788b29b"],['__file',"src/views/FAQManagement/components/contentComponents/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5788b29b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5788b29b', __exports__)) {
    api.reload('5788b29b', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=5788b29b&scoped=true", () => {
    api.rerender('5788b29b', render)
  })

}


export default __exports__